(()=>{
 const instances=new Map();
 function attach(widget){
  const viewport=widget.querySelector('.jm-carousel__viewport'),track=widget.querySelector('.jm-carousel__track');
  if(!viewport||!track)return;
  let frame=0,disposed=false,observed=new Set();
  const schedule=()=>{if(!frame&&!disposed)frame=requestAnimationFrame(update)};
  function update(){
   frame=0;if(!widget.isConnected)return;
   const cards=[...track.querySelectorAll('.jdgm-rev-snippet-card')];if(!cards.length)return;
   cards.forEach(card=>{if(!observed.has(card)){resize.observe(card);intersect.observe(card);observed.add(card)}});
   const area=viewport.getBoundingClientRect();if(!area.width)return;
   const visible=cards.filter(card=>{const r=card.getBoundingClientRect();return Math.min(r.right,area.right)-Math.max(r.left,area.left)>Math.min(r.width,area.width)*.5});
   if(!visible.length)return;
   const style=getComputedStyle(track),padding=(parseFloat(style.paddingTop)||0)+(parseFloat(style.paddingBottom)||0);
   const height=Math.ceil(Math.max(...visible.map(x=>x.getBoundingClientRect().height))+padding);
   if(Math.abs(parseFloat(viewport.style.height||'0')-height)>.5)viewport.style.height=height+'px';
  }
  const resize=new ResizeObserver(schedule),intersect=new IntersectionObserver(schedule,{root:viewport,threshold:[0,.5,1]});resize.observe(viewport);
  const mutation=new MutationObserver(schedule);mutation.observe(track,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['style','class']});
  viewport.addEventListener('scroll',schedule,{passive:true});track.addEventListener('transitionend',schedule);schedule();
  instances.set(widget,()=>{disposed=true;cancelAnimationFrame(frame);resize.disconnect();intersect.disconnect();mutation.disconnect();viewport.removeEventListener('scroll',schedule);track.removeEventListener('transitionend',schedule)});
 }
 function scan(){
  for(const [widget,dispose]of instances)if(!widget.isConnected){dispose();instances.delete(widget)}
  document.querySelectorAll('.nr-product-apps .jdgm-review-snippet-widget-v2').forEach(widget=>{if(!instances.has(widget))attach(widget)});
 }
 let queued=false;new MutationObserver(()=>{if(!queued){queued=true;queueMicrotask(()=>{queued=false;scan()})}}).observe(document.documentElement,{childList:true,subtree:true});
 scan();document.addEventListener('shopify:section:load',scan);
})();
